/**
 * Middleware to check if the session has timed out and redirect to login if necessary.
 * This prevents users from navigating within the app after their session has expired.
 */

export default async function checkSessionTimeout(to, from, next) {
    // Skip for public routes that don't require authentication
    const publicPaths = ['/', '/login', '/password/email', '/password/reset'];
    if (publicPaths.some(path => to.path === path || to.path.startsWith(`${path}/`))) {
        return next();
    }

    // Get the store
    const store = window.$nuxt?.$store || window.$store;
    if (!store) {
        return next();
    }

    // Get the session monitor
    const sessionMonitor = window.SessionMonitor;

    // Check if session has timed out
    const isSessionTimedOut =
        store.state.Auth?.sessionTimedOut || (sessionMonitor && sessionMonitor.isSessionTimedOut());

    if (isSessionTimedOut) {
        // Save the intended destination to return after login
        // Don't save '/login' as the return path
        if (to.path && !publicPaths.includes(to.path) && to.path !== '/login') {
            store.dispatch('Auth/saveReturnPath', to.fullPath);
        }

        // Redirect via SessionMonitor so return URL + session_expired notice stay consistent
        if (sessionMonitor) {
            sessionMonitor.redirectToLogin();
        } else {
            window.location.replace('/login');
        }
        return next(false); // Abort the current navigation
    }

    return next();
}
